var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8932 38.9999L1.39062 32.9237L8.60164 0.675293L39.4258 10.6121C37.0733 24.0525 35.8107 36.4422 34.8929 38.9999H34.8932Z",
    fill: "#000066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6624 37.9998L0.5 30.6074C2.42417 28.3229 4.77213 16.8848 7.09834 5.91519C7.29606 4.98232 7.44294 4.03938 7.53875 3.09053L7.85012 0L39 7.00939L38.717 9.67345C38.5708 11.0498 38.3162 12.4123 37.9567 13.748C35.0845 24.421 32.4508 34.5359 32.6624 37.9998Z",
    fill: "#1D72F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 26.7175C15.9352 26.7175 15.8855 26.7118 15.8366 26.7002C15.6195 26.649 15.4444 26.4888 15.3738 26.2771L11.5108 14.6875C11.3983 14.3502 11.5806 13.9855 11.9179 13.8733C12.2555 13.7607 12.6199 13.943 12.7322 14.2804L16.2659 24.8816L28.6641 12.4834C28.9157 12.2321 29.3231 12.2321 29.5746 12.4834C29.826 12.7348 29.826 13.1424 29.5746 13.394L16.4399 26.5287C16.3179 26.6508 16.1531 26.7175 15.9844 26.7175Z",
    fill: "#000066"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingConfirm);
export default __webpack_public_path__ + "static/media/booking-confirm.a5d85a67e2984c6274ee6aa711a1620a.svg";
export { ForwardRef as ReactComponent };